var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKemasan",
    attrs: {
      "id": "modal-kemasan",
      "title": "Tambah Kemasan",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.kemasan.jumlahKemasan),
      expression: "kemasan.jumlahKemasan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jumlah Kemasan",
      "type": "number"
    },
    domProps: {
      "value": (_vm.kemasan.jumlahKemasan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kemasan.jumlahKemasan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')))]), _vm._v(" "), _c('small', [_vm._v("Isikan Jumlah Total Kemasan")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Kemasan",
      "list": _vm.JenisKemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "placeholder": "Jenis Kemasan"
    },
    model: {
      value: (_vm.kemasan.jenisKemasan),
      callback: function($$v) {
        _vm.kemasan.jenisKemasan = $$v
      },
      expression: "kemasan.jenisKemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.submitKemasan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a98f91a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalKemasan.vue
// module id = 362
// module chunks = 0